import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { FiFilter } from "react-icons/fi";
import Badge from "../../../../../components/badge/badge";
import InputSearch from "../../../../../components/inputs/inputSearch/inputSearch";
import Button from "../../../../../components/button/button";
import { getApiInstance } from "../../../../../utils/api";
import Modal from "../../../../../components/modal/modal";
import Input from "../../../../../components/inputs/input/input";
import TableEditable from "../../../../../components/tableEditable/tableEditable";
import Notification from "../../../../../components/notification/notification";
import Accordion from "../../../../../components/accordion/accordion";
import Tag from "../../../../../components/tag/tag";
import InputDropdown from "../../../../../components/inputs/inputDropdown/inputDropdown";
import Popup from "../../../../../components/popup/popup";
import { BiExport } from "react-icons/bi";
import DateRangeCalendar from "../../../../../components/dateRangeCalendar/dateRangeCalendar";
import { matchesSearchInObject, searchByKeywords } from "../../../../../utils/searchUtils";
import { BiImport } from "react-icons/bi";
import FileList from "../../../../../components/fileList/fileList";
import InputTextfield from "../../../../../components/inputs/inputTextfield/inputTextfield";
import { formatDateComment } from "../../../../../utils/utils";
import { appendUsuariosNotificadosByEmpresa } from "../../../../../utils/notifications";


const estadoLabels = {
  1: "Coincidencia",
  2: "Sin coincidencia",
  3: "No encontrado",
  4: "Sin precio",
};

const estados = [
  { id: 1, label: "Coincidencia" },
  { id: 2, label: "Sin coincidencia" },
  { id: 3, label: "No encontrado" },
  { id: 4, label: "Sin precio" },
];

const estadoDefault = "Sin estado";

// Mapeo de estados GOI
const estadosGOIMapping = {
  1: "Pendiente",
  2: "Aprobado", 
  3: "Rechazado",
  4: "En revisión",
  5: "Nuevo",
  6: "Modificado"
};

const ValidacionGOI = ({ user }) => {
  const location = useLocation();
  const { hash, pathname, search } = location;
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSolicitudes, setSelectedSolicitudes] = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  const [filteredSolicitudes, setFilteredSolicitudes] = useState([]);
  const [filterMuebles, setFilterMuebles] = useState([]);
  const [filterProveedor, setFilterProveedor] = useState([]);
  const [filterNombreTarifa, setFilterNombreTarifa] = useState([]);
  const [filterEstado, setFilterEstado] = useState([]);
  const [filterComparativa, setFilterComparativa] = useState([]);
  
  // Estados para el modal de selección de tarifa
  const [isSeleccionTarifaModalOpen, setIsSeleccionTarifaModalOpen] = useState(false);
  const [proveedoresTarifa, setProveedoresTarifa] = useState([]);
  const [nombresTarifaGoi, setNombresTarifaGoi] = useState([]);
  const [nombresTarifaBook, setNombresTarifaBook] = useState([]);
  const [selectedProveedorTarifa, setSelectedProveedorTarifa] = useState(null);
  const [selectedNombreTarifaGoi, setSelectedNombreTarifaGoi] = useState(null);
  const [selectedNombreTarifaBook, setSelectedNombreTarifaBook] = useState(null);
  const [isLoadingTarifa, setIsLoadingTarifa] = useState(false);
  const [tarifaActivaInfo, setTarifaActivaInfo] = useState(null);
  const [filterCategoria, setFilterCategoria] = useState([]);
  const [filterSubcategoria, setFilterSubcategoria] = useState([]);
  
  // Nuevos estados para filtros GOI adicionales
  const [filterEstadoGOI, setFilterEstadoGOI] = useState([]);
  const [filterUnidad, setFilterUnidad] = useState([]);
  const [filterFechaImportacion, setFilterFechaImportacion] = useState([]);
  const [estadosGOI, setEstadosGOI] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [fechasImportacion, setFechasImportacion] = useState([]);
  
  const [filterFechaInformado, setFilterFechaInformado] = useState({
    startDate: null,
    endDate: null,
  });
  const [filterFechaSolicitud, setFilterFechaSolicitud] = useState({
    startDate: null,
    endDate: null,
  });
  const [filterDiasRestantes, setFilterDiasRestantes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
  const [editSolicitud, setEditSolicitud] = useState(null);
  const [mueblesOptions, setMueblesOptions] = useState([]);
  const [proveedoresOptions, setProveedoresOptions] = useState([]);
  const [tarifasOptions, setTarifasOptions] = useState([]);
  const [estadosOptions, setEstadosOptions] = useState(estados);
  const [categorias, setCategorias] = useState([]);
  const [subCategorias, setSubcategorias] = useState([]);
  const [usedFilter, setUsedFilter] = useState();
  const [selectedDate, setSelectedDate] = useState("");
  const [
    isPopupQuestionPropuestaTarifaOpen,
    setisPopupQuestionPropuestaTarifaOpen,
  ] = useState(false);
  const [isPopupPropuestaTarifaOpen, setIsPopupPropuestaTarifaOpen] =
    useState(false);
  const [tarifasPropuestas, setTarifasPropuestas] = useState([]);
  const [currentSolicitudIndex, setCurrentSolicitudIndex] = useState(0);
  const [currentSolicitud, setCurrentSolicitud] =
    useState();
    // solicitudes.find(
    //     (solicitud) =>
    //         solicitud.codPrecioMueble ===
    //         selectedSolicitudes[currentSolicitudIndex]
    // )
  const [isPopupAceptarTarifasOpen, setIsPopupAceptarTarifasOpen] =
    useState(false);
  const [isPopupRevisionCorrectaOpen, setIsPopupRevisionCorrectaOpen] =
    useState(false);
  const [initalCurrentPage, setInitalCurrentPage] = useState(1);
  const notificationRef = useRef(null);
  const [comparativaGOI, setComparativaGOI] = useState([]);
const comparativaHistorico = [];
  const [historicoGOI, setHistoricoGOI] = useState([]);

  const [showTableHistorico, setShowTableHistorico] = useState(false);

    // Nuevos estados para modal de importación
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [nombreTarifaGoi, setNombreTarifaGoi] = useState("");
  const [tarifasProveedorOptions, setTarifasProveedorOptions] = useState([]);
  const [selectedTarifaBook, setSelectedTarifaBook] = useState(null);
  const [importFile, setImportFile] = useState(null);
  const [isImportSubmitting, setIsImportSubmitting] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  // Importaciones / revisión antes de cerrar
  const [importaciones, setImportaciones] = useState([]);
  const [selectedImportacionId, setSelectedImportacionId] = useState(null);
  const [importResumen, setImportResumen] = useState(null);
  const [importDetalle, setImportDetalle] = useState([]);
  const [puedeCerrar, setPuedeCerrar] = useState(false);
  const [pendientesCount, setPendientesCount] = useState(null);
  const [isImportacionesModalOpen, setIsImportacionesModalOpen] = useState(false);
  const [comentariosProveedorMap, setComentariosProveedorMap] = useState({});
  const [comentariosAtlanteMap, setComentariosAtlanteMap] = useState({});
  const [comentariosPorFila, setComentariosPorFila] = useState({});

  const [isComentariosModalOpen, setIsComentariosModalOpen] = useState(false);
  const [comentarioModalRow, setComentarioModalRow] = useState(null);
  const [comentarioModalInput, setComentarioModalInput] = useState("");
  const [comentarioModalFiles, setComentarioModalFiles] = useState([]);
  const [comentarioModalInputFileText, setComentarioModalInputFileText] =
    useState("Selecciona un archivo");

  const [duplicadasModalOpen, setDuplicadasModalOpen] = useState(false);
  const [duplicadasModalData, setDuplicadasModalData] = useState([]);
  const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);
  const [pendingValidationIds, setPendingValidationIds] = useState([]);
  const [pendingValidationAction, setPendingValidationAction] = useState(true);
  // Helper: obtener filas seleccionadas según la tabla visible
  const getSelectedRows = () => {
    const source = showTableHistorico ? historicoGOI : comparativaGOI;
    const list = Array.isArray(source) ? source : [];
    
    const filtered = list.filter((row) => {
      return selectedSolicitudes.includes(row.idDetalle?.toString()) || selectedSolicitudes.includes(row.idDetalle);
    });
    
    return filtered;
  };

  // Intentar extraer un id de importación único de las filas seleccionadas.
  // Devuelve null si no hay un único id determinable.
  const getUniqueImportIdFromSelected = () => {
    const rows = getSelectedRows();
    const ids = rows
      .map(
        (r) =>
          r.IdImportacion ??
          r.idImportacion ??
          r.IdImport ??
          r.idImport ??
          r.idImportacionCabecera ??
          null
      )
      .filter(Boolean);
    const uniq = Array.from(new Set(ids));
    return uniq.length === 1 ? uniq[0] : null;
  };

  const handleCerrarTarifa = async (idImportacion) => {
    // si no recibe id, intentar extraer uno único de las filas seleccionadas
    if (!idImportacion) {
      const fallbackId = getUniqueImportIdFromSelected();
      if (fallbackId) {
        idImportacion = fallbackId;
      } else {
        notificationRef.current?.addNotification(
          "Seleccione una importación para cerrar.",
          "warning"
        );
        return;
      }
    }

    if (!window.confirm(`¿Cerrar la importación ${idImportacion}?`)) return;

    setIsClosing(true);
    try {
      const api = getApiInstance();
      const res = await api.post(`/api/GOI/Importaciones/${idImportacion}/cerrar`);
      // respuesta OK -> marcar cerrada y refrescar
      notificationRef.current?.addNotification("Importación cerrada correctamente.", "success");
      // refrescar cabecera y detalle
      await fetchImportaciones();
      await fetchComparativaGOI();
      // limpiar estado/UI
      setShowTableHistorico(true);
      setSelectedSolicitudes([]);
      setSelectedImportacionId(null);
      setImportResumen(null);
      setImportDetalle([]);
      setPuedeCerrar(false);
      setPendientesCount(0);
    } catch (err) {
      // si el backend devuelve 400 con mensaje de pendientes, mostrarlo
      if (err.response?.status === 400) {
        const msg = err.response?.data || "Aún hay líneas pendientes por validar.";
        notificationRef.current?.addNotification(msg, "warning");
        // actualizar estado de puedeCerrar/pendientes consultando el endpoint
        try {
          const api = getApiInstance();
          const check = await api.get(`/api/GOI/Importaciones/${idImportacion}/puede-cerrar`);
          const payload = check.data ?? {};
          setPuedeCerrar(Boolean(payload?.PuedeCerrar));
          setPendientesCount(Number(payload?.Pendientes ?? 0));
        } catch {
          // ignore secondary error
        }
      } else {
        const mensaje = err.response?.data || err.message || "Error al cerrar tarifa.";
        notificationRef.current?.addNotification(mensaje, "error");
      }
    } finally {
      setIsClosing(false);
    }
  };

  // Handler mínimo para acciones sobre fila (sustituir por la llamada real)
  const handleAprobarFila = async (row, aprobar = true) => {
    // extraer idDetalle de la fila (soporta varias variantes de nombre)
    const extractId = (r) => r?.idDetalle ?? r?.IdDetalle ?? r?.id_detalle ?? null;

    // si se llamó desde el botón de la fila, priorizamos ese id; si no, usamos la selección
    const idsFromRow = row ? (extractId(row) ? [extractId(row)] : []) : [];
    const idsFromSelection = getSelectedNoEncontrIds();
    const ids = idsFromRow.length ? idsFromRow : idsFromSelection;

    if (!ids.length) {
      notificationRef.current?.addNotification(
        "No hay filas 'No encontrado' seleccionadas para aprobar/desaprobar.",
        "warning"
      );
      return;
    }

    try {
      const api = getApiInstance();
      // Envío con mayúsculas para coincidir con la estructura del backend (case-insensitive de todas formas)
      const payload = { Ids: ids, Aprobar: aprobar };
      const res = await api.post("/api/GOI/Detalle/AprobarReferenciasNuevas", payload);

      const afectados = res.data?.Afectados ?? res.data?.afectados ?? null;
      notificationRef.current?.addNotification(
        afectados !== null
          ? `${aprobar ? "Aprobadas" : "Desaprobadas"} ${afectados} referencia(s).`
          : "Operación completada.",
        "success"
      );

      // refrescar detalle de la importación y lista de importaciones
      if (selectedImportacionId) await fetchImportacionDetalleYResumen(selectedImportacionId);
      await fetchImportaciones();
    } catch (err) {
      const mensaje = err.response?.data || err.message || "Error al aprobar/desaprobar referencias";
      notificationRef.current?.addNotification(mensaje, "error");
    }
  };

  const handleVerFila = (row) => {
    // Si la fila pertenece a una importación, cargar su detalle/resumen
    if (row.IdImportacion) {
      fetchImportacionDetalleYResumen(row.IdImportacion);
      setShowTableHistorico(false);
    } else {
      notificationRef.current?.addNotification(
        "No hay importación asociada a esta fila",
        "warning"
      );
    }
  };

  // Helper: detectar si la fila está marcada como "AprobadoFueraDeBook"
  const isFueraAprobado = (row) => {
    return Boolean(
      row?.AprobadoFueraDeBook ??
        row?.aprobadoFueraDeBook ??
        row?.AprobadoFueraDeBook === 1 ??
        row?.aprobadoEspecial // fallback si el backend usa otra propiedad
    );
  };

  // Obtener ids de detalle seleccionados que estén en estado "NoEncontrado" (3)
  const getSelectedNoEncontrIds = () => {
    const rows = getSelectedRows();
    
    const filteredRows = rows.filter((r) => {
      return r.codEstado === 3 && !r.esAprobado && (r.idDetalle || r.idDetalle === 0);
    });
    
    const ids = filteredRows
      .map((r) => r.idDetalle)
      .filter((id) => typeof id !== "undefined" && id !== null);
    
    // deduplicar
    return Array.from(new Set(ids));
  };

  // Botón "Validar" que aprueba las referencias "NoEncontrado" (AprobadoFueraDeBook = 1)
  const handleValidarSeleccionados = async (aprobar = true) => {
    const ids = getSelectedNoEncontrIds();
    if (!ids.length) {
      notificationRef.current?.addNotification(
        "Seleccione filas 'No encontrado' para validar.",
        "warning"
      );
      return;
    }

    // Guardar los IDs y la acción para el popup
    setPendingValidationIds(ids);
    setPendingValidationAction(aprobar);
    setIsConfirmPopupOpen(true);
  };

  // Función para confirmar la validación desde el popup
  const handleConfirmValidation = async () => {
    setIsConfirmPopupOpen(false);
    
    try {
      const api = getApiInstance();
      await api.post(`/api/GOI/Detalle/AprobarReferenciasNuevas`, {
        ids: pendingValidationIds,
        aprobar: pendingValidationAction,
      });

      notificationRef.current?.addNotification(
        `Se han ${pendingValidationAction ? "validado" : "deshecho"} ${pendingValidationIds.length} referencias.`,
        "success"
      );

      // refrescar detalle y comprobación de cierre para la importación actual
      if (selectedImportacionId) {
        await fetchImportacionDetalleYResumen(selectedImportacionId);
      }
      await fetchImportaciones();
    } catch (err) {
      const mensaje = err.response?.data || err.message || "Error al validar referencias";
      notificationRef.current?.addNotification(mensaje, "error");
    } finally {
      // Limpiar estados
      setPendingValidationIds([]);
      setPendingValidationAction(true);
    }
  };

  // Función para cancelar la validación desde el popup
  const handleCancelValidation = () => {
    setIsConfirmPopupOpen(false);
    setPendingValidationIds([]);
    setPendingValidationAction(true);
  };

  const handleOpenComentariosModal = (row) => {
    setComentarioModalRow(row);
    setComentarioModalInput("");
    setComentarioModalFiles([]);
    setIsComentariosModalOpen(true);
  };


  const columnsTarifas = [
    {
      key: "estado",
      label: "Estado",
      render: (row) => {
        // Si es NoEncontrado pero aprobado fuera del Book, mostrar chip verde distinto
        if (row?.estado === 3 && isFueraAprobado(row)) {
          return <Badge label="Fuera de Book (aprobado)" variant="success" />;
        }

        let variant;
        const estadoLegible = estadoLabels[row.estado] || "Sin estado";

        switch (row.estado) {
          case 1:
            variant = "success";
            break;
          case 2:
            variant = "danger";
            break;
          case 3:
            variant = "info";
            break;
          case 4:
            variant = "warning";
            break;
          default:
            variant = "default";
        }

        return <Badge label={estadoLegible} variant={variant} />;
      },
      editable: false,
    },
    // columna "Imagen" eliminada
    { key: "referencia", label: "Referencia", editable: false },
    { key: "descripcion", label: "Descripción", editable: false },
    {
      key: "precioGOI",
      label: "Precio GOI",
      type: "number",
      editable: false,
      required: false,
      render: (row) => {
        if (row.precioGOI === 0 || row.precioGOI === null || row.precioGOI === "undefined") {
          return "-";
        }
        
        const precioGOI = parseFloat(row.precioGOI);
        const precioBook = parseFloat(row.precioBook);
        const isMatch = !isNaN(precioGOI) && !isNaN(precioBook) && Math.abs(precioGOI - precioBook) < 0.01;
        
        return (
          <span style={{
            color: isMatch ? '#28a745' : '#dc3545',
            fontWeight: isMatch ? '600' : '500',
            textDecoration: isMatch ? 'none' : 'underline',
            textDecorationStyle: isMatch ? 'none' : 'wavy'
          }}>
            {row.precioGOI}
          </span>
        );
      },
    },
        {
      key: "unidad",
      label: "Unidad GOI",
      type: "number",
      editable: false,
      render: (row) => {
        if (row.unidad === 0 || row.unidad === null) {
          return "-";
        }
        
        const unidadGOI = row.unidad?.toString()?.trim();
        const unidadBook = row.unidadBOOK?.toString()?.trim();
        const isMatch = unidadGOI && unidadBook && unidadGOI === unidadBook;
        
        return (
          <span style={{
            color: isMatch ? '#28a745' : '#dc3545',
            fontWeight: isMatch ? '600' : '500',
            textDecoration: isMatch ? 'none' : 'underline',
            textDecorationStyle: isMatch ? 'none' : 'wavy'
          }}>
            {row.unidad}
          </span>
        );
      },
    },
    {
      key: "precioBook",
      label: "Precio Book",
      type: "number",
      editable: false,
      render: (row) => {
        if (row.precioBook === 0 || row.precioBook === null) {
          return "-";
        }
        
        const precioGOI = parseFloat(row.precioGOI);
        const precioBook = parseFloat(row.precioBook);
        const isMatch = !isNaN(precioGOI) && !isNaN(precioBook) && Math.abs(precioGOI - precioBook) < 0.01;
        
        return (
          <span style={{
            color: '#28a745',
            fontWeight: '600',
            backgroundColor: isMatch ? 'rgba(40, 167, 69, 0.1)' : 'transparent',
            padding: isMatch ? '2px 4px' : '0',
            borderRadius: isMatch ? '3px' : '0'
          }}>
            {row.precioBook}
          </span>
        );
      },
    },
    {
      key: "unidadBOOK",
      label: "Unidad Book",
      type: "number",
      editable: false,
      render: (row) => {
        if (row.unidadBOOK === 0 || row.unidadBOOK === null) {
          return "-";
        }
        
        const unidadGOI = row.unidad?.toString()?.trim();
        const unidadBook = row.unidadBOOK?.toString()?.trim();
        const isMatch = unidadGOI && unidadBook && unidadGOI === unidadBook;
        
        return (
          <span style={{
            color: '#28a745',
            fontWeight: '600',
            backgroundColor: isMatch ? 'rgba(40, 167, 69, 0.1)' : 'transparent',
            padding: isMatch ? '2px 4px' : '0',
            borderRadius: isMatch ? '3px' : '0'
          }}>
            {row.unidadBOOK}
          </span>
        );
      },
    },
    {
      key: "fechaImportacion",
      label: "Fecha importación",
      editable: false,
      render: (row) =>
        row.fechaImportacion
          ? new Date(row.fechaImportacion).toLocaleDateString("es-ES", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })
          : "-",
    },
    {
      key: "nombreEmpresa",
      label: "Proveedor",
      editable: false,
      render: (row) => row.nombreEmpresa || "-",
    },
    {
          key: "verComentarios",
          label: "Comentarios",
          render: (row) => (
            <Button
              label="Ver comentarios"
              variant="outlined"
              onClick={() => handleOpenComentariosModal(row)}
            />
          ),
          editable: false,
        },
    {
      key: "acciones",
      label: "Acciones",
      render: (row) => {
        const fuera = isFueraAprobado(row);
        const actionLabel = fuera ? "Desaprobar" : "Aprobar";
        const isNoEncontrado = row.codEstado === 3;
        
        return (
          <div style={{ display: "flex", gap: 8 }}>
            {isNoEncontrado && (
              <Button
                label={actionLabel}
                variant="outline"
                onClick={() => handleAprobarFila(row, !fuera)}
              />
            )}
            {/* <Button
              label="Ver"
              variant="outline"
              onClick={() => handleVerFila(row)}
            /> */}
          </div>
        );
      },
      editable: false,
    },
    // {
    //     key: "showAll",
    //     label: "Desglosar precios",
    //     render: (row) => (
    //         <Button
    //             label="Desglosar precios"
    //             onClick={() => handleEditSolicitud(row)}
    //         />
    //     ),
    // },
  ];

   const columnsHistorico = [
    {
      key: "estado",
      label: "Estado",
      render: (row) => {
        if (row?.estado === 3 && isFueraAprobado(row)) {
          return <Badge label="Fuera de Book (aprobado)" variant="success" />;
        }

        let variant;
        const estadoLegible = estadoLabels[row.estado] || "Sin estado";

        switch (row.estado) {
          case 1:
            variant = "success";
            break;
          case 2:
            variant = "danger";
            break;
          case 3:
            variant = "info";
            break;
          case 4:
            variant = "warning";
            break;
          default:
            variant = "default";
        }

        return <Badge label={estadoLegible} variant={variant} />;
      },
      editable: false,
    },
    {
      key: "rutaImagenMueble",
      label: "Imagen",
      render: (row) => (
        <img
          src={row.rutaImagenMueble || "defaultImage.png"}
          alt={row.nombreMueble || "Sin nombre"}
          style={{
            maxWidth: "48px",
            maxHeight: "48px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        />
      ),
      editable: false,
    },
    { key: "referencia", label: "Referencia", editable: false },
    { key: "descripcion", label: "Descripción", editable: false },
    {
      key: "precioUnidad",
      label: "Precio Unidad",
      type: "number",
      editable: false,
      required: false,
      render: (row) => {
        if (row.precioUnidad == 0 || row.precioUnidad == null || row.precioUnidad == "undefined") {
          return "-";
        }
        return `${row.precioUnidad}`;
      },
    },
    {
      key: "precioGOI",
      label: "Precio GOI",
      type: "number",
      editable: false,
      required: false,
      render: (row) => {
        if (row.precioGOI === 0 || row.precioGOI === null || row.precioGOI === undefined) {
          return "-";
        }
        return `${row.precioGOI}`;
      },
    },
    { key: "divisa", label: "Divisa", editable: false },
    { key: "unidad", label: "Unidad", editable: false },
    { key: "fecha", label: "Fecha", editable: false,
        render: (row) => {
                const date = new Date(row.fecha);
                return date.toLocaleDateString();
            },
     },
    // {
    //     key: "showAll",
    //     label: "Desglosar precios",
    //     render: (row) => (
    //         <Button
    //             label="Desglosar precios"
    //             onClick={() => handleEditSolicitud(row)}
    //         />
    //     ),
    // },
  ];

  // Definir columnas para la tabla de importaciones
  const columnsImportaciones = [
    { 
      key: "ArchivoNombre", 
      label: "Archivo", 
      editable: false 
    },
    {
      key: "Empresa",
      label: "Proveedor",
      editable: false,
      render: (row) => row.Empresa || "-"
    },
    { 
      key: "FechaSubida", 
      label: "Fecha", 
      editable: false,
      render: (row) => {
        const date = new Date(row.FechaSubida);
        return date.toLocaleDateString();
      }
    },
    { 
      key: "Total", 
      label: "Total", 
      editable: false 
    },
    { 
      key: "Pendientes", 
      label: "Pendientes", 
      editable: false,
      render: (row) => {
        return Math.max(
          0,
          (row.Total || 0) - ((row.Coinc || 0) + (row.FueraOK || 0))
        );
      }
    },
    {
      key: "acciones",
      label: "Acciones",
      render: (row) => (
        <Button
          label="Abrir"
          variant="outline"
          onClick={() => {
            fetchImportacionDetalleYResumen(row.IdImportacion);
            setIsImportacionesModalOpen(false);
            setShowTableHistorico(false);
          }}
        />
      ),
      editable: false,
    }
  ];

  // Estado para filas seleccionadas en la tabla de importaciones
  const [selectedImportaciones, setSelectedImportaciones] = useState([]);

  useEffect(() => {
      // Al entrar en la vista cargamos comparativa y también las importaciones abiertas
      const init = async () => {
        await fetchComparativaGOI();
        await fetchProveedores(); // Añadir esta línea
        const imports = await fetchImportaciones();
        // seleccionar la primera importación abierta (no cerrada) si existe
        const firstOpen = (imports || []).find((imp) => !imp.Cerrada);
        if (firstOpen?.IdImportacion) {
          setSelectedImportacionId(firstOpen.IdImportacion);
          // obtener detalle/resumen y comprobación de cierre
          await fetchImportacionDetalleYResumen(firstOpen.IdImportacion);
        }
      };
      init();
  }, []);

  useEffect(() => {
    setCurrentSolicitud(
      solicitudes.find(
        (solicitud) =>
          solicitud.codPrecioMueble ===
          selectedSolicitudes[currentSolicitudIndex]
      )
    );
  }, [selectedSolicitudes, currentSolicitudIndex, solicitudes]);

  const fetchComparativaGOI = async () => {
    const api = getApiInstance();
    try {
      const response = await api.get(
        `/api/MueblesPrecios/GetHistoricoComparativa`
      );
      setHistoricoGOI(response.data);
      setHistoricoGOI(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error al obtener el histórico:", error);
      setHistoricoGOI([]);
    }
  };

  const fetchImportaciones = async (q = "") => {
    try {
      const api = getApiInstance();
      // Usar el endpoint global (no filtra por empresa)
      const res = await api.get("/api/GOI/Importaciones/Global", {
        params: { tipo: "Tarifa", cerrada: false, q, top: 100 },
      });

      // DEBUG: log para inspección si hace falta
      console.debug("[ValidacionGOI] fetchImportaciones (global) response:", res);

      // Normalizar nombres (la API puede devolver camelCase)
      const raw = Array.isArray(res.data) ? res.data : [];
      const normalized = raw.map((item) => ({
        IdImportacion: item.idImportacion ?? item.IdImportacion ?? item.Id ?? null,
        CodEmpresa: item.codEmpresa ?? item.CodEmpresa ?? item.codProveedor ?? null,
        NombreEmpresa: item.nombreEmpresa ?? item.NombreEmpresa ?? item.nombreProveedor ?? null,
        ArchivoNombre: item.archivoNombre ?? item.ArchivoNombre ?? item.archivo ?? item.nombreArchivo ?? null,
        FechaSubida: item.fechaSubida ?? item.FechaSubida ?? item.fecha ?? null,
        Total: item.total ?? item.Total ?? 0,
        Coinc: item.coinc ?? item.Coinc ?? 0,
        NoCoinc: item.noCoinc ?? item.NoCoinc ?? 0,
        NoEncontr: item.noEncontr ?? item.NoEncontr ?? 0,
        SinPrecio: item.sinPrecio ?? item.SinPrecio ?? 0,
        FueraOK: item.fueraOK ?? item.FueraOK ?? 0,
        NombreTarifaGoi: item.nombreTarifaGoi ?? item.NombreTarifaGoi ?? item.nombre ?? null,
        NombreTarifaBook: item.nombreTarifaBook ?? item.NombreTarifaBook ?? item.nombreBook ?? null,
        Cerrada: item.cerrada ?? item.Cerrada ?? false,
      }));
      setImportaciones(normalized);
      return normalized;
    } catch (err) {
      console.error("[ValidacionGOI] fetchImportaciones error:", err);
      notificationRef.current?.addNotification("Error al cargar importaciones (global)", "error");
      return [];
    }
  };

  const fetchImportacionDetalleYResumen = async (id) => {
    if (!id) return;
    try {
      const api = getApiInstance();
      const [resResumen, resDetalle, resPuedeCerrar] = await Promise.all([
        api.get(`/api/GOI/Importaciones/${id}/resumen`),
        api.get(`/api/GOI/Importaciones/${id}/detalle`),
        api.get(`/api/GOI/Importaciones/${id}/puede-cerrar`),
      ]);

    // DEBUG: inspeccionar respuestas
    console.debug("[ValidacionGOI] fetchImportacionDetalleYResumen id:", id);
    console.debug("[ValidacionGOI] resResumen.data:", resResumen?.data);
    console.debug("[ValidacionGOI] importaciones (local):", importaciones);

    const rawResumen = resResumen.data ?? {};

    // Primero intentar obtener nombre desde la lista global ya cargada (Importaciones/Global),
    // porque en tu ejemplo ese endpoint sí devuelve nombreTarifaBook.
    const globalImp = (importaciones || []).find(
      (imp) =>
        Number(imp.IdImportacion) === Number(id) ||
        Number(imp.idImportacion) === Number(id)
    );

    let nombreTarifaBookFromResumen =
      globalImp?.NombreTarifaBook ??
      globalImp?.nombreTarifaBook ??
      null;

    // Si no lo encontramos en la lista global, caer al resumen y a claves alternativas
    if (!nombreTarifaBookFromResumen) {
      nombreTarifaBookFromResumen =
        rawResumen.NombreTarifaBook ??
        rawResumen.nombreTarifaBook ??
        rawResumen.nombreBook ??
        rawResumen.nombreTarifa ??
        rawResumen.nombre ??
        null;
    }

    const normalizedResumen = {
      NombreTarifaBook: nombreTarifaBookFromResumen,
      NombreTarifaGoi:
        rawResumen.NombreTarifaGoi ?? rawResumen.nombreTarifaGoi ?? rawResumen.nombreGoi ?? null,
      IdImportacion:
        rawResumen.IdImportacion ?? rawResumen.idImportacion ?? rawResumen.Id ?? id,
      ...rawResumen,
    };

    console.debug("[ValidacionGOI] normalizedResumen:", normalizedResumen);

    setImportResumen(normalizedResumen);

    const detalleArray = Array.isArray(resDetalle.data) ? resDetalle.data : [];
    setImportDetalle(detalleArray);
    setComparativaGOI(detalleArray);

    const payload = resPuedeCerrar.data ?? {};
    setPuedeCerrar(Boolean(payload?.PuedeCerrar));
    setPendientesCount(Number(payload?.Pendientes ?? 0));
    setSelectedImportacionId(id);
  } catch (err) {
    console.error("[ValidacionGOI] Error fetchImportacionDetalleYResumen:", err);
    notificationRef.current?.addNotification("Error al cargar detalle de importación", "error");
  }
};
  // Usar esta función para recargar lista y limpiar selección
  const refreshImportaciones = async () => {
    await fetchImportaciones();
    setSelectedImportacionId(null);
    setImportResumen(null);
    setImportDetalle([]);
    setPuedeCerrar(false);
    setPendientesCount(null);
  };

  // Función para obtener proveedores del endpoint
  const fetchProveedores = async () => {
    try {
      const api = getApiInstance();
      const response = await api.get("/api/Empresa/GetAllEmpresas");
      
      console.log("Respuesta completa de empresas:", response.data);
      
      // Filtrar solo empresas de tipo proveedor (codTipoEmpresa === 3)
      const proveedores = response.data
        .filter(empresa => empresa.codTipoEmpresa === 3)
        .map(empresa => ({
          id: empresa.codEmpresa,
          nombre: empresa.nombre
        }));
      
      console.log("Proveedores filtrados:", proveedores);
      setProveedoresOptions(proveedores);
    } catch (error) {
      console.error("Error al obtener proveedores:", error);
      notificationRef.current?.addNotification("Error al cargar proveedores", "error");
    }
  };

  // Funciones para el modal de selección de tarifa
  const fetchProveedoresTarifa = async () => {
    try {
      const api = getApiInstance();
      console.log("Llamando a /api/GOI/Tarifas/Proveedores");
      const response = await api.get("/api/GOI/Tarifas/Proveedores");
      console.log("Respuesta de proveedores:", response.data);
      setProveedoresTarifa(response.data || []);
    } catch (error) {
      console.error("Error al obtener proveedores de tarifa:", error);
      notificationRef.current?.addNotification("Error al cargar proveedores", "error");
    }
  };

  const fetchNombresTarifaGoi = async (codEmpresa) => {
    try {
      const api = getApiInstance();
      const response = await api.get(`/api/GOI/Tarifas/NombresGoi?codEmpresa=${codEmpresa}`);
      console.log("Respuesta NombresGoi:", response.data);
      // Extraer los nombres del array de objetos
      const nombres = (response.data || []).map(item => item.nombre);
      console.log("Nombres extraídos:", nombres);
      setNombresTarifaGoi(nombres);
    } catch (error) {
      console.error("Error al obtener nombres de tarifa GOI:", error);
      notificationRef.current?.addNotification("Error al cargar tarifas GOI", "error");
    }
  };

  const fetchNombresTarifaBook = async (codEmpresa, nombreTarifaGoi) => {
    try {
      const api = getApiInstance();
      const response = await api.get(`/api/GOI/Tarifas/NombresBook?codEmpresa=${codEmpresa}&nombreTarifaGoi=${encodeURIComponent(nombreTarifaGoi)}`);
      console.log("Respuesta NombresBook:", response.data);
      // Extraer los nombres del array de objetos (asumiendo la misma estructura)
      const nombres = Array.isArray(response.data) 
        ? response.data.map(item => typeof item === 'string' ? item : item.nombre)
        : [];
      console.log("Nombres Book extraídos:", nombres);
      setNombresTarifaBook(nombres);
    } catch (error) {
      console.error("Error al obtener nombres de tarifa Book:", error);
      notificationRef.current?.addNotification("Error al cargar tarifas Book", "error");
    }
  };

  const handleProveedorTarifaSelect = (selectedValue) => {
    console.log("Proveedor seleccionado:", selectedValue);
    
    // El InputDropdown puede devolver el objeto completo o solo el valor
    const codEmpresa = typeof selectedValue === 'object' ? selectedValue.value : selectedValue;
    console.log("Código de empresa extraído:", codEmpresa);
    
    const proveedor = proveedoresTarifa.find(p => p.codEmpresa === codEmpresa);
    console.log("Proveedor encontrado:", proveedor);
    setSelectedProveedorTarifa(proveedor);
    setSelectedNombreTarifaGoi(null);
    setSelectedNombreTarifaBook(null);
    setNombresTarifaGoi([]);
    setNombresTarifaBook([]);
    
    if (proveedor) {
      console.log("Llamando a fetchNombresTarifaGoi con codEmpresa:", proveedor.codEmpresa);
      fetchNombresTarifaGoi(proveedor.codEmpresa);
    }
  };

  const handleNombreTarifaGoiSelect = (selectedValue) => {
    console.log("Tarifa GOI seleccionada:", selectedValue);
    
    // Extraer el valor si es un objeto
    const nombreTarifaGoi = typeof selectedValue === 'object' ? selectedValue.value : selectedValue;
    console.log("Nombre tarifa GOI extraído:", nombreTarifaGoi);
    
    setSelectedNombreTarifaGoi(nombreTarifaGoi);
    setSelectedNombreTarifaBook(null);
    setNombresTarifaBook([]);
    
    if (nombreTarifaGoi && selectedProveedorTarifa) {
      console.log("Llamando a fetchNombresTarifaBook con:", selectedProveedorTarifa.codEmpresa, nombreTarifaGoi);
      fetchNombresTarifaBook(selectedProveedorTarifa.codEmpresa, nombreTarifaGoi);
    }
  };

  const handleNombreTarifaBookSelect = (selectedValue) => {
    console.log("Tarifa Book seleccionada:", selectedValue);
    
    // Extraer el valor si es un objeto
    const nombreTarifaBook = typeof selectedValue === 'object' ? selectedValue.value : selectedValue;
    console.log("Nombre tarifa Book extraído:", nombreTarifaBook);
    
    setSelectedNombreTarifaBook(nombreTarifaBook);
  };

  const handleCargarTarifa = async () => {
    if (!selectedNombreTarifaGoi || !selectedNombreTarifaBook || !selectedProveedorTarifa) {
      notificationRef.current?.addNotification("Selecciona todas las opciones", "warning");
      return;
    }

    setIsLoadingTarifa(true);
    try {
      const api = getApiInstance();
      const response = await api.get(`/api/GOI/Tarifas/Activa?nombreTarifaGoi=${encodeURIComponent(selectedNombreTarifaGoi)}&nombreTarifaBook=${encodeURIComponent(selectedNombreTarifaBook)}&codEmpresa=${selectedProveedorTarifa.codEmpresa}`);
      
      const idImportacion = response.data?.idImportacion;
      if (idImportacion) {
        // Almacenar la información completa de la tarifa activa
        setTarifaActivaInfo(response.data);
        setSelectedImportacionId(idImportacion);
        await fetchImportacionDetalleYResumen(idImportacion);
        setIsSeleccionTarifaModalOpen(false);
        notificationRef.current?.addNotification("Tarifa cargada correctamente", "success");
      } else {
        notificationRef.current?.addNotification("No se pudo obtener la importación activa", "error");
      }
    } catch (error) {
      console.error("Error al cargar tarifa activa:", error);
      notificationRef.current?.addNotification("Error al cargar la tarifa", "error");
    } finally {
      setIsLoadingTarifa(false);
    }
  };

  const handleCloseSeleccionTarifaModal = () => {
    setIsSeleccionTarifaModalOpen(false);
    setSelectedProveedorTarifa(null);
    setSelectedNombreTarifaGoi(null);
    setSelectedNombreTarifaBook(null);
    setProveedoresTarifa([]);
    setNombresTarifaGoi([]);
    setNombresTarifaBook([]);
  };



    const fetchComentarios = async () => {
      const api = getApiInstance();
      try {
        const response = await api.get(
          `/api/GOI/GetAllComentarios/${comentarioModalRow.idDetalle}`
        );
  
        if (response.status !== 200) {
          notificationRef.current?.addNotification(
            "Error cargando comentarios.",
            "error"
          );
          return;
        }
  
        const comentarios = response.data.map((com) => ({
          codComentario: com.codComentario,
          comentario: com.comentario,
          nombreUsuario:
            com.nombreUsuario == user.nombre ? "Tú" : com.nombreUsuario,
          fecha: formatDateComment(com.fecha),
          rutasArchivos: com.rutasArchivos || [],
        }));
  
        // Actualiza el estado de comentarios por fila
  
        setComentariosPorFila((prev) => {
          const id = comentarioModalRow.idDetalle;
          const prevList = prev[id] ?? [];
  
          // Índice por codComentario para mezclar sin duplicar
          const map = new Map(prevList.map((c) => [c.codComentario, c]));
  
          for (const c of comentarios) {
            // Si ya existe, actualízalo; sino, añádelo
            map.set(c.codComentario, {
              ...(map.get(c.codComentario) ?? {}),
              ...c,
            });
          }
  
          const merged = Array.from(map.values());
  
          return {
            ...prev,
            [id]: merged,
          };
        });
      } catch (error) {
        console.error(error);
      }
    };
  
      const fetchSendNotification = async (comentario) => {
        try {
          const api = getApiInstance();
    
          const formData = new FormData();

          // Obtener información detallada para la notificación
          const referencia = comentarioModalRow?.referencia ?? 
                            comentarioModalRow?.Referencia ?? 
                            "Sin referencia";
          
          // Obtener nombres de tarifa desde el array importaciones
          const importacionActual = importaciones.find(imp => imp.IdImportacion === selectedImportacionId);
          
          const tarifaGoi = importacionActual?.NombreTarifaGoi ?? 
                           importacionActual?.nombreTarifaGoi ?? 
                           "Tarifa GOI no especificada";
          
          const tarifaBook = importacionActual?.NombreTarifaBook ?? 
                            importacionActual?.nombreTarifaBook ?? 
                            importResumen?.NombreTarifaBook ?? 
                            importResumen?.nombreTarifaBook ?? 
                            "Tarifa Book no especificada";

          // Crear mensaje detallado siguiendo el patrón de especiales
          const mensajeDetallado = `Comentario: "${comentario.comentario}" | Tarifa GOI: ${tarifaGoi} | Tarifa Book: ${tarifaBook}`;
    
          // Tipos destinatarios
          // None = 0,
          // Admin = 1,
          // Todos = 2,
          // Personalizado = 3
          // AdminProveedores = 4
    
          const codEmpresaProveedor =
            selectedProveedorTarifa?.codEmpresa ??
            tarifaActivaInfo?.codEmpresa ??
            tarifaActivaInfo?.CodEmpresa ??
            importResumen?.codEmpresa ??
            importResumen?.CodEmpresa ??
            importacionActual?.CodEmpresa ??
            importacionActual?.codEmpresa ??
            comentarioModalRow?.codEmpresa ??
            comentarioModalRow?.CodEmpresa ??
            comentarioModalRow?.codProveedor ??
            null;

          if (!codEmpresaProveedor) {
            console.warn(
              "No se pudo determinar la empresa del proveedor para la notificaciÃ³n GOI."
            );
            return;
          }

          const codUsuariosNotificados = await appendUsuariosNotificadosByEmpresa(
            formData,
            api,
            codEmpresaProveedor
          );

          if (codUsuariosNotificados.length === 0) {
            console.warn(
              "No se encontraron usuarios para notificar en la empresa:",
              codEmpresaProveedor
            );
            return;
          }

          formData.append("CodUsuarioNotifica", user.codUsuario);
          formData.append("CodUsuarioExcluir", user.codUsuario); // Excluir al usuario que envía el comentario
          formData.append("Mensaje", mensajeDetallado);
          formData.append("Titulo", `Nuevo comentario en validación GOI - ${referencia}`);
          
          // Tipos notificación (sin aplicación en el front por ahora)
          // Info = 0,
          // Warning = 1,
          // Error = 2
    
          formData.append("TipoNotificacion", 0);
          
          // Las notificaciones van a AdminProveedores, dirigir a la vista de proveedores
          const enlace = selectedImportacionId 
            ? `/admin/solicitudes-tarifas?activeTab=validacionGOI&importacionId=${selectedImportacionId}&referencia=${encodeURIComponent(referencia)}`
            : `/admin/solicitudes-tarifas?activeTab=validacionGOI`;
          formData.append("Enlace", enlace);
    
          let response = await api.post(`/api/Notificaciones`, formData);
        } catch (error) {
          console.error("Error enviando notificación:", error);
        }
      };
  
  useEffect(() => {
    if (isComentariosModalOpen && comentarioModalRow) {
      fetchComentarios();
    }
  }, [isComentariosModalOpen, comentarioModalRow]);

  useEffect(() => {
    if (isSeleccionTarifaModalOpen) {
      fetchProveedoresTarifa();
    }
  }, [isSeleccionTarifaModalOpen]);  useEffect(() => {
    // Para generar opciones, aplicamos TODOS los filtros excepto el que estamos generando
    const getFilteredDataExcluding = (excludeFilter) => {
      const source = showTableHistorico ? historicoGOI : comparativaGOI;
      const list = Array.isArray(source) ? source : [];
      return list.filter((solicitud) => {
         // Búsqueda por término
         if (searchTerm) {
           const matchesSearch = matchesSearchInObject(
             solicitud,
             searchTerm
           );
           if (!matchesSearch) return false;
         }

         // Aplicar todos los filtros EXCEPTO el que estamos excluyendo
         if (excludeFilter !== "mueble" && filterMuebles.length > 0) {
            if (!filterMuebles.includes(solicitud.codMueble)) return false;
          }

          if (excludeFilter !== "proveedor" && filterProveedor.length > 0) {
            if (!filterProveedor.includes(solicitud.codEmpresa || solicitud.codProveedor)) return false;
          }

          if (
            excludeFilter !== "nombreTarifa" &&
            filterNombreTarifa.length > 0
          ) {
            if (!filterNombreTarifa.includes(solicitud.nombreTarifa))
              return false;
          }

          if (excludeFilter !== "estado" && filterEstado.length > 0) {
            const estadoIds = filterEstado.map((estado) => estado.id);
            if (!estadoIds.includes(solicitud.estado)) return false;
          }

          return true;
        }
      );
    };

    const dataForMuebles = getFilteredDataExcluding("mueble");
    setMueblesOptions(
      Array.from(
        new Map(
          dataForMuebles.map((solicitud) => [
            solicitud.codMueble,
            {
              id: solicitud.codMueble,
              nombre: solicitud.referencia,
            },
          ])
        ).values()
      )
    );

    const dataForProveedores = getFilteredDataExcluding("proveedor");
    const proveedoresFromData = Array.from(
      new Map(
        dataForProveedores
          .filter(solicitud => solicitud.codEmpresa || solicitud.codProveedor)
          .map((solicitud) => [
            solicitud.codEmpresa || solicitud.codProveedor,
            {
              id: solicitud.codEmpresa || solicitud.codProveedor,
              nombre: solicitud.nombreEmpresa || solicitud.nombreProveedor || `Proveedor ${solicitud.codEmpresa || solicitud.codProveedor}`,
            },
          ])
      ).values()
    );
    
    // Combinar proveedores de la API con los que aparecen en los datos
    const allProveedores = [...proveedoresOptions];
    proveedoresFromData.forEach(prov => {
      if (!allProveedores.find(p => p.id === prov.id)) {
        allProveedores.push(prov);
      }
    });
    
    if (allProveedores.length !== proveedoresOptions.length) {
      setProveedoresOptions(allProveedores);
    }

    const dataForTarifas = getFilteredDataExcluding("nombreTarifa");
    setTarifasOptions(
      Array.from(
        new Map(
          dataForTarifas.map((solicitud) => [
            solicitud.nombreTarifa,
            {
              id: solicitud.nombreTarifa,
              nombre: solicitud.nombreTarifa,
            },
          ])
        ).values()
      )
    );

    const dataForEstados = getFilteredDataExcluding("estado");
    setEstadosOptions(
      Array.from(
        new Map(
          dataForEstados.map((solicitud) => [
            solicitud.estado,
            {
              id: solicitud.estado,
              nombre: estados.find((estado) => estado.id === solicitud.estado)
                .label,
            },
          ])
        ).values()
      )
    );
  }, [
    searchTerm,
    filterMuebles,
    filterProveedor, // Añadir esta dependencia
    filterNombreTarifa,
    filterEstado,
    historicoGOI,
    comparativaGOI,
    proveedoresOptions, // Añadir esta dependencia
  ]);

  // Nuevo useEffect para generar opciones de filtros GOI
  useEffect(() => {
    console.log('Datos para filtros GOI:', comparativaGOI);
    
    // Extraer estados únicos
    const allEstadosGOI = comparativaGOI
      .map((item) => item.estado)
      .filter((value, index, self) => self.indexOf(value) === index && value != null)
      .map((estado) => ({
        id: estado,
        nombre: estadosGOIMapping[estado] || `Estado ${estado}`
      }));

    // Extraer unidades únicas
    const allUnidades = comparativaGOI
      .map((item) => item.unidad)
      .filter((value, index, self) => self.indexOf(value) === index && value != null);

    // Extraer fechas de importación únicas (solo fecha, sin hora)
    const allFechasImportacion = comparativaGOI
      .map((item) => {
        if (item.fechaImportacion) {
          return new Date(item.fechaImportacion).toLocaleDateString();
        }
        return null;
      })
      .filter((value, index, self) => self.indexOf(value) === index && value != null);

    setEstadosGOI(allEstadosGOI);
    setUnidades(allUnidades);
    setFechasImportacion(allFechasImportacion);
  }, [comparativaGOI]);

  // Añadir handler para selección de proveedor
  const handleSelectProveedor = (selectedIds) => {
    setUsedFilter("proveedor");
    setFilterProveedor(selectedIds);
  };

  // Modificar handleCleanFilter para limpiar también el filtro de proveedor
  const handleCleanFilter = () => {
    setFilterProveedor([]); // Añadir esta línea
    // Limpiar filtros GOI restantes
    setFilterEstado([]);
    setFilterUnidad([]);
    setFilterFechaImportacion([]);
  };

  // Handler para seleccionar muebles
  const handleSelecteMueble = (selectedIds) => {
    setUsedFilter("mueble");
    setFilterMuebles(selectedIds);
  };

  // Handler para seleccionar nombre tarifa
  const handleSelectNombreTarifa = (selectedIds) => {
    setUsedFilter("nombreTarifa");
    setFilterNombreTarifa(selectedIds);
  };

  // Handler para seleccionar estado
  const handleSelectEstado = (estado) => {
    setUsedFilter("estado");
    setFilterEstado((prev) => {
      const isSelected = prev.some(item => item.id === estado.id);
      if (isSelected) {
        return prev.filter(item => item.id !== estado.id);
      } else {
        return [...prev, estado];
      }
    });
  };

  // Nuevos handlers para filtros GOI
  const handleSelectEstadoGOI = (estado) => {
    setFilterEstadoGOI((prevSelected) => {
      if (prevSelected.some(e => e.id === estado.id)) {
        return prevSelected.filter(e => e.id !== estado.id);
      } else {
        return [...prevSelected, estado];
      }
    });
  };

  const handleSelectUnidad = (unidadName) => {
    setFilterUnidad((prevSelected) => {
      if (prevSelected.includes(unidadName)) {
        return prevSelected.filter(
          (unidad) => unidad !== unidadName
        );
      } else {
        return [...prevSelected, unidadName];
      }
    });
  };

  const handleSelectFechaImportacion = (fechaName) => {
    setFilterFechaImportacion((prevSelected) => {
      if (prevSelected.includes(fechaName)) {
        return prevSelected.filter(
          (fecha) => fecha !== fechaName
        );
      } else {
        return [...prevSelected, fechaName];
      }
    });
  };

  // Función para cerrar modal
  const closeModal = () => {
    setIsModalOpen(false);
    setEditSolicitud(null);
  };

const handleExportExcel = async () => {
        try {
          if (selectedSolicitudes.length === 0) {
            notificationRef.current.addNotification(
              "No hay solicitudes seleccionadas para exportar.",
              "warning"
            );
            return;
          }
          
          if (!selectedImportacionId) {
            notificationRef.current.addNotification(
              "No hay importación seleccionada.",
              "warning"
            );
            return;
          }
          
          // Convertir IDs seleccionados a objetos completos si es necesario
          const currentData = showTableHistorico ? historicoGOI : filteredDatosGOI;
          const selectedObjects = currentData.filter(item => 
            selectedSolicitudes.includes(item.idDetalle)
          );
          
          console.log('IDs seleccionados:', selectedSolicitudes);
          console.log('Objetos encontrados:', selectedObjects);
          
          if (selectedObjects.length === 0) {
            notificationRef.current.addNotification(
              "Error: No se pudieron encontrar los datos seleccionados.",
              "error"
            );
            return;
          }
          
          // El endpoint espera directamente un array de IDs (enteros)
          const selectedIds = selectedObjects.map(obj => obj.idDetalle);
          
          console.log('IDs para enviar al endpoint:', selectedIds);
          
          const api = getApiInstance();
          const response = await api.post(
            `/api/GOI/ExportarGOI/${selectedImportacionId}`,
            selectedIds,  // Enviar directamente el array de IDs
            { responseType: "blob" }
          );
    
          if (response.status !== 200) {
            throw new Error("Error al descargar el archivo");
          }
    
          const blob = await response.data;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
    
          let fileName = "Validaciones_GOI.xlsx";
          const disposition = response.headers.get("Content-Disposition");
          if (disposition && disposition.indexOf("filename=") !== -1) {
            const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
            if (fileNameMatch && fileNameMatch.length > 1) {
              fileName = fileNameMatch[1];
            }
          }
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
    
          notificationRef.current.addNotification(
            "Archivo descargado correctamente.",
            "success"
          );
        } catch (error) {
          notificationRef.current.addNotification(
            "Error al descargar el archivo.",
            "error"
          );
          console.error("Error al descargar el archivo:", error);
        }
      };

  const handleSearch = (query) => {
    setSearchTerm(query);

    if (!query.trim()) {
      setFilteredSolicitudes(solicitudes);
      return;
    }

    const resultados = searchByKeywords(solicitudes, query, [
      "referencia",
      "nombreMueble",
      "descripcion",
      "nombreTarifa",
      "nombreCategoria",
      "nombreFamilia",
      "nombreSubfamilia",
      "comentariosProveedor",
    ]);

    setFilteredSolicitudes(resultados);
  };

  // Filtrar datos GOI con los nuevos filtros
  const filteredDatosGOI = useMemo(() => {
    let filtered = comparativaGOI.filter((item) =>
      matchesSearchInObject(item, searchTerm)
    );

    // Aplicar filtros específicos GOI
    if (filterEstado.length > 0) {
      filtered = filtered.filter((item) =>
        filterEstado.some(estado => estado.id === item.estado)
      );
    }

    if (filterEstadoGOI.length > 0) {
      filtered = filtered.filter((item) =>
        filterEstadoGOI.some(estado => estado.id === item.estado)
      );
    }

    if (filterUnidad.length > 0) {
      filtered = filtered.filter((item) =>
        filterUnidad.includes(item.unidad)
      );
    }

    if (filterFechaImportacion.length > 0) {
      filtered = filtered.filter((item) => {
        if (item.fechaImportacion) {
          const fechaItem = new Date(item.fechaImportacion).toLocaleDateString();
          return filterFechaImportacion.includes(fechaItem);
        }
        return false;
      });
    }

    return filtered;
  }, [
    searchTerm,
    comparativaGOI,
    filterEstado,
    filterEstadoGOI,
    filterUnidad,
    filterFechaImportacion,
  ]);

  const visibleSolicitudes = useMemo(() => {
    let filtered = [...filteredSolicitudes];

    if (filterMuebles.length > 0) {
      filtered = filtered.filter((solicitud) =>
        filterMuebles.includes(solicitud.codMueble)
      );
    }

    if (filterProveedor.length > 0) {
      filtered = filtered.filter((solicitud) =>
        filterProveedor.includes(solicitud.codEmpresa || solicitud.codProveedor)
      );
    }

    if (filterNombreTarifa.length > 0) {
      filtered = filtered.filter((solicitud) =>
        filterNombreTarifa.includes(solicitud.nombreTarifa)
      );
    }

    if (filterEstado.length > 0) {
      filtered = filtered.filter((solicitud) =>
        filterEstado.map((estado) => estado.id).includes(solicitud.estado)
      );
    }

    return filtered;
  }, [filteredSolicitudes, filterMuebles, filterProveedor, filterNombreTarifa, filterEstado]);

  // Nuevo manejador: enviar modal de importación
  const handleSubmitImportModal = async () => {
    if (!nombreTarifaGoi.trim()) {
      notificationRef.current?.addNotification("Nombre tarifa GOI requerido", "warning");
      return;
    }
    if (!selectedTarifaBook) {
      notificationRef.current?.addNotification("Seleccione una tarifa Book", "warning");
      return;
    }
    if (!importFile) {
      notificationRef.current?.addNotification("Seleccione un fichero Excel", "warning");
      return;
    }

    setIsImportSubmitting(true);
    try {
      const api = getApiInstance();
      const tarifaBookParam =
        typeof selectedTarifaBook === "string"
          ? selectedTarifaBook
          : selectedTarifaBook?.value ?? selectedTarifaBook?.label ?? "";
      const params = `?nombreTarifaGoi=${encodeURIComponent(
        nombreTarifaGoi
      )}&nombreTarifaBook=${encodeURIComponent(tarifaBookParam)}`;
      const formData = new FormData();
      formData.append("archivoExcel", importFile);

      const response = await api.post(`/api/GOI/ImportarTarifaProveedor${params}`, formData);
      const data = response.data || [];
      setComparativaGOI(Array.isArray(data) ? data : []);
      setShowTableHistorico(false);
      const newId =
        response.data?.IdImportacion ??
        response.data?.idImportacion ??
        response.data?.Id ??
        response.data?.id ??
        null;
      if (newId) {
        setSelectedImportacionId(newId);
        await fetchImportacionDetalleYResumen(newId);
      }
      await fetchImportaciones();
      setIsImportModalOpen(false);
      setNombreTarifaGoi("");
      setSelectedTarifaBook(null);
      setImportFile(null);
      notificationRef.current?.addNotification("Muebles importados correctamente", "success");
    } catch (error) {
      // Manejo especial para referencias duplicadas
      const data = error.response?.data;
      if (
        data &&
        (data.referenciasDuplicadasExcel || data.ReferenciasDuplicadasExcel)
      ) {
        setDuplicadasModalData(
          data.referenciasDuplicadasExcel || data.ReferenciasDuplicadasExcel
        );
        setDuplicadasModalOpen(true);
      } else {
        const mensaje = error.response?.data?.mensaje || error.response?.data || "Error al importar tarifas desde Excel.";
        notificationRef.current?.addNotification(mensaje, "error");
      }
    } finally {
      setIsImportSubmitting(false);
    }
  };

  const handleImportExcel = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("archivoExcel", file);

    try {
      const api = getApiInstance();
      const response = await api.post(
        `/api/MueblesPrecios/ImportarArchivoGOI`,
        formData
      );

      //setSolicitudes(formattedData);
      setComparativaGOI(response.data);

      setShowTableHistorico(false);

      notificationRef.current.addNotification(
        "Muebles importados correctamente",
        "success"
      );
      //await fetchSolicitudes()
    } catch (error) {
      const mensaje =
        error.response?.data || "Error al importar tarifas desde Excel.";
      notificationRef.current.addNotification(mensaje, "error");
    }
  };

    const handleShowHistorico = async () => {
    // Si actualmente mostramos histórico, el usuario quiere ver "importado"
    if (showTableHistorico) {
      // Si no hay importación seleccionada, abrir modal para elegir una
      if (!selectedImportacionId) {
        setIsImportacionesModalOpen(true);
        return;
      }
      // Si hay importación seleccionada, cargar su detalle y pasar a vista "importado"
      await fetchImportacionDetalleYResumen(selectedImportacionId);
      setShowTableHistorico(false);
      setInitalCurrentPage(1);
      return;
    }

    // Si actualmente mostramos "importado", volvemos al histórico
    setShowTableHistorico(true);
    setInitalCurrentPage(1);
    // recargar comparativa/histórico al volver
    await fetchComparativaGOI();
  };

    const handleCloseComentariosModal = () => {
      setIsComentariosModalOpen(false);
      setComentarioModalRow(null);
      setComentarioModalInput("");
      setComentarioModalFiles([]);
    };
  
    // Manejar archivos en el modal
    const handleComentarioModalFiles = (event) => {
      const filesArray = Array.from(event.target.files);
      setComentarioModalFiles((prevFiles) => [
        ...prevFiles,
        ...filesArray.filter(
          (file) => !prevFiles.some((prevFile) => prevFile.name === file.name)
        ),
      ]);
    };
  
    useEffect(() => {
      if (comentarioModalFiles.length === 0) {
        setComentarioModalInputFileText("Selecciona un archivo");
      } else {
        setComentarioModalInputFileText(
          `${comentarioModalFiles.length} ${
            comentarioModalFiles.length > 1
              ? "archivos seleccionados"
              : "archivo seleccionado"
          }`
        );
      }
    }, [comentarioModalFiles]);
  
    // Simulación de envío de comentario (puedes adaptar para llamar a tu API)
    const handleEnviarComentarioModal = async () => {
       const api = getApiInstance();
      if (!comentarioModalInput.trim() || !comentarioModalRow) return;
      try {
        const fecha = new Date();
        const formData = new FormData();
  
        formData.append("CodMueble", comentarioModalRow.idDetalle);
        formData.append("Comentario", comentarioModalInput);
        formData.append("Fecha", fecha.toLocaleString());
        comentarioModalFiles.forEach((file) => {
          formData.append("RutasArchivos", file);
        });
  
        // Usa el endpoint de detalleMueble
        const response = await api.post(
          `/api/GOI/Comentario`,
          formData
        );
  
        if (response.status === 200) {
          notificationRef.current?.addNotification(
            "Comentario creado correctamente.",
            "success"
          );
  
          const nuevoComentario = {
            codComentario: response.data.codComentario,
            comentario: comentarioModalInput,
            nombreUsuario: "Tú",
            fecha: formatDateComment(fecha.toISOString()),
            rutasArchivos: comentarioModalFiles,
          };
  
          setComentariosPorFila((prev) => ({
            ...prev,
            [comentarioModalRow.idDetalle]: [
              ...(prev[comentarioModalRow.idDetalle] || []),
              nuevoComentario,
            ],
          }));
          setComentarioModalInput("");
          setComentarioModalFiles([]);

        // Enviar notificación
        await fetchSendNotification(nuevoComentario);

        } else {
          notificationRef.current?.addNotification(
            "Hubo un error al guardar el comentario.",
            "error"
          );
        }
      } catch (error) {
        notificationRef.current?.addNotification(
          "Hubo un error al guardar el comentario.",
          "error"
        );
      }
    };

  return (
    <section className="dashboard-usuarios">
      <div className="dashboard-usuarios__content__table-header">
        <InputSearch
          context="tableSearch"
          placeholder="Buscar..."
          onSearch={handleSearch}
        />
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <div className="dashboard-productos__content__table-header__buttons" style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <Button
              variant="outline"
              label="Filtros"
              icon={<FiFilter />}
              onClick={() => setIsFiltersModalOpen(true)}
            />
            <Button
              label="Seleccionar Tarifa"
              variant="outline"
              onClick={() => setIsSeleccionTarifaModalOpen(true)}
            />
            <Button
              label="Aprobar seleccionados"
              variant="outline"
              onClick={() => handleValidarSeleccionados(true)}
              disabled={getSelectedNoEncontrIds().length === 0}
            />
            <input
              type="file"
              id="input-import-tarifas"
              accept=".xlsx, .xls"
              style={{ display: "none" }}
              onChange={handleImportExcel}
            />
            <Button
              label="Exportar"
              variant="outline"
              icon={<BiExport />}
              onClick={handleExportExcel}
              disabled={selectedSolicitudes.length === 0}
            />
          </div>

          {/* Mostrar información de la tarifa activa: Proveedor, Tarifa GOI y Tarifa Book */}
          <div style={{ marginLeft: 8, display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
            {tarifaActivaInfo ? (
              <>
                <div style={{ fontSize: 14, color: "#333", whiteSpace: "nowrap" }}>
                  <strong>Proveedor:</strong>{" "}
                  <span style={{ fontWeight: 600 }}>
                    {tarifaActivaInfo.nombreEmpresa || "—"}
                  </span>
                </div>
                <div style={{ fontSize: 14, color: "#333", whiteSpace: "nowrap" }}>
                  <strong>Tarifa GOI:</strong>{" "}
                  <span style={{ fontWeight: 600 }}>
                    {tarifaActivaInfo.nombreTarifaGoi || "—"}
                  </span>
                </div>
                <div style={{ fontSize: 14, color: "#333", whiteSpace: "nowrap" }}>
                  <strong>Tarifa Book:</strong>{" "}
                  <span style={{ fontWeight: 600 }}>
                    {tarifaActivaInfo.nombreTarifaBook || "—"}
                  </span>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>

      {showTableHistorico ? (
        <TableEditable
          data={historicoGOI}
          columns={columnsHistorico}
          rowKey="idDetalle"
          onRowSelect={setSelectedSolicitudes}
          selectedRows={selectedSolicitudes}
          notificationRef={notificationRef}
          noResultsMessage="No hay solicitudes de tarifas pendientes."
          statesRestrictEdit={[]}
          initalCurrentPage={initalCurrentPage}
        />
      ) : (
        <TableEditable
          data={filteredDatosGOI}
          columns={columnsTarifas}
          rowKey="idDetalle"
          onRowSelect={setSelectedSolicitudes}
          selectedRows={selectedSolicitudes}
          notificationRef={notificationRef}
          noResultsMessage="No hay solicitudes de tarifas pendientes."
          statesRestrictEdit={[]} 
          initalCurrentPage={initalCurrentPage}
        />
      )}

      <Modal
        title="Filtros"
        isOpen={isFiltersModalOpen}
        onClose={() => setIsFiltersModalOpen(false)}
        onAccept={() => setIsFiltersModalOpen(false)}
        outlineButtonLabel="Limpiar"
        primaryButtonLabel={`Ver resultados (${filteredDatosGOI.length})`}
        onCancel={handleCleanFilter}
      >
        <div className="modal-inputs">
          <div className="section-header__modal__section">
            <Accordion title="Estado">
              <ul className="section-header__modal__section__content">
                {estados.map((estado) => (
                  <Tag
                    key={estado.id}
                    label={estado.label}
                    isSelected={filterEstado.some(e => e.id === estado.id)}
                    onSelect={() => handleSelectEstado(estado)}
                  />
                ))}
              </ul>
            </Accordion>
          </div>

          <div className="section-header__modal__section">
            <Accordion title="Unidad">
              <ul className="section-header__modal__section__content">
                {unidades.map((unidad, index) => (
                  <Tag
                    key={index}
                    label={unidad}
                    isSelected={filterUnidad.includes(unidad)}
                    onSelect={() => handleSelectUnidad(unidad)}
                  />
                ))}
              </ul>
            </Accordion>
          </div>

          <div className="section-header__modal__section">
            <Accordion title="Fecha Importación">
              <ul className="section-header__modal__section__content">
                {fechasImportacion.map((fecha, index) => (
                  <Tag
                    key={index}
                    label={fecha}
                    isSelected={filterFechaImportacion.includes(fecha)}
                    onSelect={() => handleSelectFechaImportacion(fecha)}
                  />
                ))}
              </ul>
            </Accordion>
          </div>
        </div>
      </Modal>

            {/* Modal de importación */}
      <Modal
        title="Importar Tarifas GOI"
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
        onAccept={handleSubmitImportModal}
        outlineButtonLabel="Cancelar"
        primaryButtonLabel={isImportSubmitting ? "Importando..." : "Importar"}
      >
        <div className="modal-inputs">
          <div className="section-header__modal__section">
            <Input
              label="Nombre tarifa GOI"
              value={nombreTarifaGoi}
              onChange={(e) => setNombreTarifaGoi(e.target.value)}
              required
            />
          </div>

          <div className="section-header__modal__section">
            <InputDropdown
              label="Tarifa Book"
              options={tarifasProveedorOptions}
              onSelect={(val) => {
                // Normalizar y guardar SOLO el string (value) para evitar [object Object]
                const raw = Array.isArray(val) ? (val.length ? val[0] : null) : val;
                const normalized =
                  raw == null
                    ? null
                    : typeof raw === "string"
                    ? raw
                    : raw.value ?? raw.label ?? null;
                setSelectedTarifaBook(normalized);
              }}
              withCheckboxes={false}
              hasSearch={true}
            />
          </div>

          <div className="section-header__modal__section">
            <label>Archivo Excel</label>
            <input
              type="file"
              accept=".xlsx, .xls"
              onChange={(e) => setImportFile(e.target.files?.[0] || null)}
            />
          </div>
        </div>
      </Modal>
      <Modal
        title="Importaciones abiertas"
        isOpen={isImportacionesModalOpen}
        onClose={() => setIsImportacionesModalOpen(false)}
        outlineButtonLabel="Cerrar"
        className="modal--table"
        hideFooter={true}
      >
        <div className="modal-table-container" style={{ width: '100%', height: 'calc(100vh - 200px)', overflow: 'auto' }}>
          <TableEditable
            data={importaciones}
            columns={columnsImportaciones}
            rowKey="IdImportacion"
            onRowSelect={setSelectedImportaciones}
            selectedRows={selectedImportaciones}
            notificationRef={notificationRef}
            noResultsMessage="No hay importaciones abiertas."
            statesRestrictEdit={[]}
            showPagination={false}
            showRowsPerPage={false}
            showHeaderCheckbox={false}
          />
        </div>
      </Modal>

      <Modal
        title="Precios desglosados"
        isOpen={isModalOpen}
        onClose={closeModal}
        outlineButtonLabel="Cancelar"
      >
        <div className="dashboard-usuarios__modal">
          <form
            className="dashboard-usuarios__modal__content"
            autoComplete="off"
          >
            <p
              style={{
                fontSize: "14px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              <strong>Prototipo: </strong>
              {editSolicitud?.prototipo}
            </p>
            <p
              style={{
                fontSize: "14px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              <strong>Precio unidad ignífugo: </strong>
              {editSolicitud?.precioUnidadIgnifugo}
            </p>
            <p
              style={{
                fontSize: "14px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              <strong>Precio masivo: </strong>
              {editSolicitud?.precioMasivo}
            </p>
            <p
              style={{
                fontSize: "14px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              <strong>Cantidad pedido masivo: </strong>
              {editSolicitud?.cantidadPedidoMasivo}
            </p>
            <p
              style={{
                fontSize: "14px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              <strong>Coste fabricación: </strong>
              {editSolicitud?.costeFabricacion}
            </p>

            <p
              style={{
                fontSize: "14px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              <strong>Coste materiales: </strong>
              {editSolicitud?.costeMateriales}
            </p>
            <p
              style={{
                fontSize: "14px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              <strong>Coste maquinaria: </strong>
              {editSolicitud?.costeMaquinaria}
            </p>
            <p
              style={{
                fontSize: "14px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              <strong>Coste mano de obra: </strong>
              {editSolicitud?.costeManoObra}
            </p>
            <p
              style={{
                fontSize: "14px",
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              <strong>Porcentaje beneficio sobre coste: </strong>
              {editSolicitud?.porcentajeBeneficioSobreCoste}
            </p>
          </form>
        </div>
      </Modal>
      
      {/* Modal de comentarios */}
      <Modal
        title={`Comentarios de ${comentarioModalRow?.referencia || ""}`}
        isOpen={isComentariosModalOpen}
        onClose={handleCloseComentariosModal}
        onCancel={handleCloseComentariosModal}
        hideFooter={true}
        className="modal--centered"
      >
        <div className="detalle-mueble__info__comments">
          <div className="detalle-mueble__info__comments__comments-list">
            {comentarioModalRow &&
            (comentariosPorFila[comentarioModalRow.idDetalle] || []).length >
              0 ? (
              <>
                {(comentariosPorFila[comentarioModalRow.idDetalle] || []).map(
                  (com, idx) => (
                    <div
                      key={com.codComentario}
                      className="detalle-mueble__info__comments__comments-list__item"
                    >
                      <div className="detalle-mueble__info__comments__comments-list__item__info">
                        <div className="detalle-mueble__info__comments__comments-list__item__author">
                          <div className="avatar">
                            <div className="avatar__inner">
                              {com.nombreUsuario.charAt(0).toUpperCase()}
                            </div>
                          </div>
                          <p>{com.nombreUsuario}</p>
                          {com.fecha && (
                            <span style={{ marginLeft: 8, color: "#888" }}>
                              ({com.fecha})
                            </span>
                          )}
                        </div>
                      </div>
                      <p className="detalle-mueble__info__comments__comments-list__item__comment">
                        {com.comentario || (
                          <span style={{ color: "#aaa" }}>Sin comentario</span>
                        )}
                      </p>
                      {com.rutasArchivos && com.rutasArchivos.length > 0 && (
                        <FileList files={com.rutasArchivos} filesVisible={3} />
                      )}
                    </div>
                  )
                )}
              </>
            ) : (
              <p
                className="detalle-mueble__info__comments__comments-list__item__comment"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "12px 0",
                  fontWeight: "700",
                }}
              >
                Todavía no hay comentarios en este mueble.
              </p>
            )}
          </div>
          {/* Formulario para agregar comentario */}
          <div className="detalle-mueble__info__comments__add-comment">
            <InputTextfield
              label="Escribe tu comentario"
              value={comentarioModalInput}
              onChange={(e) => setComentarioModalInput(e.target.value)}
              placeholder="Escribe aquí tu comentario..."
            />
            <Input
              type="file"
              label="Archivo adjunto"
              name="archivoAdjunto"
              placeholder={comentarioModalInputFileText}
              multipleFiles={true}
              onChange={handleComentarioModalFiles}
            />
            {comentarioModalFiles.length > 0 && (
              <FileList
                files={comentarioModalFiles}
                handleDelete={(file) =>
                  setComentarioModalFiles((prev) =>
                    prev.filter((f) => f.name !== file.name)
                  )
                }
              />
            )}
            <Button
              label="Enviar comentario"
              variant="filled"
              onClick={handleEnviarComentarioModal}
            />
          </div>
        </div>
      </Modal>

      <Notification ref={notificationRef} />

      {/* Modal para referencias duplicadas en Excel */}
      <Modal
        title="Referencias duplicadas en el Excel"
        isOpen={duplicadasModalOpen}
        onClose={() => setDuplicadasModalOpen(false)}
        outlineButtonLabel="Cerrar"
        hideFooter={true}
      >
        <div>
          <p style={{ marginBottom: 12 }}>
            El archivo contiene referencias duplicadas. Revisa el Excel antes de volver a importarlo.
          </p>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", borderBottom: "1px solid #eee", padding: "4px 8px" }}>Referencia</th>
                <th style={{ textAlign: "left", borderBottom: "1px solid #eee", padding: "4px 8px" }}>Repeticiones</th>
              </tr>
            </thead>
            <tbody>
              {duplicadasModalData.map((item) => (
                <tr key={item.referencia}>
                  <td style={{ padding: "4px 8px" }}>{item.referencia}</td>
                  <td style={{ padding: "4px 8px" }}>{item.repeticiones}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>

      {/* Modal de selección de tarifa */}
      <Modal
        title="Seleccionar Tarifa"
        isOpen={isSeleccionTarifaModalOpen}
        onClose={handleCloseSeleccionTarifaModal}
        onAccept={handleCargarTarifa}
        primaryButtonLabel={isLoadingTarifa ? "Cargando..." : "Cargar Tarifa"}
        outlineButtonLabel="Cancelar"
        acceptButtonDisabled={!selectedProveedorTarifa || !selectedNombreTarifaGoi || !selectedNombreTarifaBook || isLoadingTarifa}
      >
        <div className="modal-inputs">
          <div className="section-header__modal__section">
            <InputDropdown
              label="Proveedor"
              options={(() => {
                const options = proveedoresTarifa.map((proveedor) => ({
                  label: proveedor.nombre,
                  value: proveedor.codEmpresa,
                }));
                console.log("Opciones de proveedores:", options);
                return options;
              })()}
              onSelect={(value) => {
                console.log("onSelect llamado con:", value);
                handleProveedorTarifaSelect(value);
              }}
              withCheckboxes={false}
              hasSearch={true}
              placeholder="Seleccionar proveedor..."
              selectedValues={selectedProveedorTarifa ? [selectedProveedorTarifa.codEmpresa] : []}
            />
          </div>

          <div className="section-header__modal__section">
            <InputDropdown
              label="Nombre Tarifa GOI"
              options={nombresTarifaGoi.map((nombre) => ({
                label: nombre,
                value: nombre,
              }))}
              onSelect={handleNombreTarifaGoiSelect}
              withCheckboxes={false}
              hasSearch={true}
              placeholder="Seleccionar tarifa GOI..."
              disabled={!selectedProveedorTarifa}
            />
          </div>

          <div className="section-header__modal__section">
            <InputDropdown
              label="Nombre Tarifa Book"
              options={nombresTarifaBook.map((nombre) => ({
                label: nombre,
                value: nombre,
              }))}
              onSelect={handleNombreTarifaBookSelect}
              withCheckboxes={false}
              hasSearch={true}
              placeholder="Seleccionar tarifa Book..."
              disabled={!selectedNombreTarifaGoi}
            />
          </div>
        </div>
      </Modal>

      {/* Popup de confirmación para validar referencias */}
      {isConfirmPopupOpen && (
        <Popup
          type="alert"
          alertType="information"
          titleMessage="Confirmar validación"
          alertMessage={`¿Desea ${pendingValidationAction ? "aprobar" : "deshacer"} ${pendingValidationIds.length} referencias?`}
          onConfirm={handleConfirmValidation}
          onClose={handleCancelValidation}
          confirmLabel={pendingValidationAction ? "Aprobar" : "Deshacer"}
          cancelLabel="Cancelar"
        />
      )}
    </section>
  );
};

export default ValidacionGOI;
